<template>

    <div class="list-view-section ml-xl-4 mr-xl-1 pt-3 pb-1" data-aos="fade-up">

        <draggable tag="div" class="mb-2" :list="presentations" v-bind="presentationsDragOptions" @change="elementsOrderChange">

            <div class="set-row" v-for="(presentation, index) in presentations" :key="presentation.identifier">

                <div class="set-heading" :class="{'checked': selectedPresentations.includes(presentation.identifier)}">
                    <div class="handler set-handler" :class="{'hidden': selectedSortType !== 'order'}"></div>
                    <div class="type-color" :class="[presentationSlidesType(presentation)]"></div>
                    <div class="number">{{ index+1 }}.</div>
                    <div class="name">{{ presentation.name }}</div>
                    <div class="processing-badge" v-if="hasProcessingVideos(presentation)">{{ t.__('Przetwarzanie') }} {{ getProcessingVideosProgress(presentation) }}%</div>
                    <div class="error-badge" v-if="hasErrorVideos(presentation)">{{ t.__('Błąd przetwarzania') }}</div>
                    <div class="ml-auto">&nbsp;</div>
                    <div class="slides-count">{{ t.__('lość slajdów') }}: {{ presentation.slides.length }}</div>
                    <div class="edit-btn" @click="editPresentation(presentation)"></div>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" v-model="selectedPresentations" :value="presentation.identifier">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>

            </div>

        </draggable>

        <div class="add-presentation" @click="addPresentation">
            <div class="icon"></div>
            <div class="text">{{ t.__('Dodaj materiał') }}</div>
        </div>

    </div>

</template>

<script>

import draggable from 'vuedraggable'

export default {

    name: 'PresentationPackageListView',

    components: {
        draggable
    },

    props: {
        presentations: Array,
        selectedSortType: String
    },

    data() {
        return {
            eventHub: window.eventHub,
            selectedPresentations: [],
            presentationsDragOptions: {
                animation: 200,
                group: 'games',
                disabled: false,
                ghostClass: 'ghost',
                chosenClass: 'chosen',
                handle: '.set-handler',
                draggable: '.set-row',
                dragoverBubble: true
            }
        };
    },

    computed: {
        presentationSlidesType() {
            return presentation => {
                if (presentation.slides.every(slide => slide.type === 'image')) {
                    return 'presentation';
                }
                if (presentation.slides.every(slide => slide.type === 'video')) {
                    return 'video';
                }
                return 'mixed';
            }
        },
        hasProcessingVideos() {
            return presentation => {
                let hasProcessingVideos = false;
                presentation.slides.some(slide => {
                    if (slide.processing === 1) {
                        hasProcessingVideos = true;
                    }
                    return hasProcessingVideos;
                });
                return hasProcessingVideos;
            }
        },
        getProcessingVideosProgress() {
            return presentation => {
                let processingVideosCount = 0;
                let processingVideosPercentageSum = 0;
                presentation.slides.some(slide => {
                    if (slide.processing === 1) {
                        processingVideosCount++;
                        processingVideosPercentageSum = processingVideosPercentageSum + slide.progress;
                    }
                });
                return Math.round(processingVideosPercentageSum / processingVideosCount);
            }
        },
        hasErrorVideos() {
            return presentation => {
                let hasErrorVideos = false;
                presentation.slides.some(slide => {
                    if (slide.processing === 2) {
                        hasErrorVideos = true;
                    }
                    return hasErrorVideos;
                });
                return hasErrorVideos;
            }
        }
    },

    watch: {
        selectedPresentations(newValue, oldValue) {
            this.eventHub.$emit('presentation-package-sync-selected', this.selectedPresentations);
        },
    },

    beforeMount() {

    },

    methods: {

        addPresentation() {
            this.eventHub.$emit('presentation-package-add-presentation');
        },

        editPresentation(presentation) {
            this.eventHub.$emit('presentation-package-edit-presentation', presentation);
        },

        elementsOrderChange() {
            this.eventHub.$emit('presentation-package-order-changed', this.presentations);
        }

    }

}
</script>

<style scoped>
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
</style>
